import React, { useContext } from "react";
// import { Routes, Route  } from "react-router-dom";
import { Link } from 'react-router-dom';
import "./TopNav.css";

import logo from "../images/fdxvalogo.png";
import AuthContext from "../context/AuthContext";

// const url = "https://fdxva.org/myfdx.php?epoch=" + Date.now()

const TopNav = (props) => {
  const { admin, darkmode } = useContext(AuthContext);

  console.log(props)

  return (
    <div className={`topnav ${darkmode ? 'dark' : ''}`}>
      <div className="topnav-logo">
        <Link to="/">
        <img className="topnav-logo-image" src={logo} alt="FDXVA LOGO"></img>
        </Link>
      </div>

      <div className="topnav-navbar">
        <Link className="topnav-navbar_item" to="/">Home</Link>
        <Link className="topnav-navbar_item" to="/routes">Routes</Link>
        <Link className="topnav-navbar_item" to="/inflight">InFlight</Link>
        <Link className="topnav-navbar_item" to="/operations">Operations</Link>
        <Link className="topnav-navbar_item" to="/messages">Messages</Link>
        {admin?.title &&
          <Link className="topnav-navbar_item" to="/admin-home">Admin</Link>
        }
        
      </div>

    </div>


  );
};
export default React.memo(TopNav);
